import get from 'lodash/get';

// TUNE-11677 - fix stream restarts in Apple WebKit browsers
// TUNE-12337 - replace identification strategy with `navigator.vendor`
//
// Detect macOS Safari and iOS browsers
// (Apple requires all browsers in iOS to use the affected WebKit)
// https://developer.apple.com/app-store/review/guidelines/#2.5.6

/* eslint-disable no-undef */
export default function isAppleWebKitBrowser() {
  const vendor = get(window, 'navigator.vendor', '');
  return /apple/i.test(vendor);
}
/* eslint-enable no-undef */
